import React, { useEffect, useState } from 'react';
import {
  subscribeUploads,
  dismissUploadJob,
  dismissFinishedUploads,
  clearUploadJobError
} from '../../utils/backgroundUploads';
import './BackgroundUploadPanel.css';

const formatBytes = (n) => {
  const num = Number(n) || 0;
  if (num < 1024) return `${num} B`;
  if (num < 1024 * 1024) return `${(num / 1024).toFixed(1)} KB`;
  return `${(num / (1024 * 1024)).toFixed(1)} MB`;
};

const statusLabel = (job) => {
  if (job.status === 'queued') return 'Sırada';
  if (job.status === 'uploading') {
    if (job.retrying) return `Yeniden deneniyor (${(job.attempt || 0) + 1})…`;
    return `Yükleniyor %${job.progress || 0}`;
  }
  if (job.status === 'done') return 'Tamamlandı';
  if (job.status === 'error') return 'Hata';
  return '';
};

const BackgroundUploadPanel = () => {
  const [jobs, setJobs] = useState([]);
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => subscribeUploads(setJobs), []);

  if (!jobs.length) return null;

  const active = jobs.filter((j) => j.status === 'queued' || j.status === 'uploading').length;
  const done = jobs.filter((j) => j.status === 'done').length;
  const failed = jobs.filter((j) => j.status === 'error').length;

  return (
    <div className={`bg-upload-panel ${collapsed ? 'is-collapsed' : ''}`} role="status" aria-live="polite">
      <div className="bg-upload-header">
        <button type="button" className="bg-upload-title-btn" onClick={() => setCollapsed((v) => !v)}>
          <span className="bg-upload-title">
            {active > 0 ? `Belge yükleniyor (${active})` : 'Yükleme paneli'}
          </span>
          <span className="bg-upload-meta">
            {done > 0 ? `${done} tamam` : ''}
            {done > 0 && failed > 0 ? ' · ' : ''}
            {failed > 0 ? `${failed} hata` : ''}
          </span>
          <span className="bg-upload-chevron">{collapsed ? '▲' : '▼'}</span>
        </button>
        {(done > 0 || failed > 0) && (
          <button type="button" className="bg-upload-clear" onClick={dismissFinishedUploads} title="Bitmişleri kapat">
            Temizle
          </button>
        )}
      </div>

      {!collapsed && (
        <ul className="bg-upload-list">
          {jobs.map((job) => (
            <li key={job.id} className={`bg-upload-item status-${job.status}`}>
              <div className="bg-upload-row">
                <div className="bg-upload-name" title={job.fileName}>{job.fileName}</div>
                <div className="bg-upload-size">{formatBytes(job.fileSize)}</div>
              </div>
              <div className="bg-upload-bar-wrap">
                <div
                  className="bg-upload-bar"
                  style={{ width: `${job.status === 'done' ? 100 : (job.progress || 0)}%` }}
                />
              </div>
              <div className="bg-upload-footer">
                <span className={`bg-upload-status status-${job.status}`}>
                  {job.status === 'error' ? job.error : statusLabel(job)}
                </span>
                <div className="bg-upload-actions">
                  {job.status === 'error' && (
                    <button type="button" onClick={() => clearUploadJobError(job.id)}>Tekrar dene</button>
                  )}
                  {(job.status === 'done' || job.status === 'error') && (
                    <button type="button" onClick={() => dismissUploadJob(job.id)}>Kapat</button>
                  )}
                </div>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default BackgroundUploadPanel;
